module.exports = __webpack_public_path__ + "static/media/order-preparing.0cc8a319.gif";